import React from 'react'

import poweredBy from '@/assets/images/powered_by_vertical.png'
import wordmark from '@/assets/images/wordmark.svg'
import { FOOTER_HEIGHT } from '@/utils/constants'

/**
 * Footer
 *
 * A component that provides a consistent footer for the application.
 *
 * @returns {JSX.Element} - The rendered Footer component.
 */
// shrink-0: the page area is a flex column (Routes), and a long page would otherwise
// squeeze the footer down to the height of its logos.
const Footer = () => (
  <div
    className="bg-midnight relative flex w-full shrink-0 place-content-center items-center"
    style={{ height: `${FOOTER_HEIGHT}px` }}
  >
    <div className="flex w-full flex-row items-center justify-center gap-8 md:gap-12">
      <img aria-hidden="true" className="z-10 h-6 sm:h-7" src={wordmark} alt="Logo" />
      <img
        aria-hidden="true"
        className="z-10 h-8 sm:h-9"
        src={poweredBy}
        alt="Powered By Warranty Processing"
      />
    </div>
  </div>
)

export default Footer
